import { ArrowPosition } from '@ael/core-api';
import { PanoramaRenderApi } from '@ael/core-api';

export class IndicatorRenderer {
  private _name: string;
  private _points: ArrowPosition[];
  private _indicatorPosition: number;
  private _indicatorScale: number;
  private _onClick: (() => void) | undefined;

  constructor(
    name: string,
    points: ArrowPosition[],
    indicatorPosition: number,
    indicatorScale: number,
    onClick?: () => void
  ) {
    this._name = name;
    this._points = points;
    this._indicatorPosition = indicatorPosition;
    this._indicatorScale = indicatorScale;
    this._onClick = onClick;
  }

  render(pano: PanoramaRenderApi) {
    pano.addIndicator(
      this._name,
      this._points[this._indicatorPosition].xAxis,
      this._points[this._indicatorPosition].yAxis,
      this._indicatorScale,
      this._onClick
    );
  }
}
